import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const RSS = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function RSS({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        d='M3 3.74999C3 3.47385 3.22392 3.24925 3.49995 3.25703C5.66047 3.31791 7.79319 3.77293 9.79263 4.60113C11.9462 5.49315 13.9029 6.8006 15.5511 8.44884C17.1994 10.0971 18.5068 12.0538 19.3989 14.2074C20.2271 16.2068 20.6821 18.3395 20.743 20.5C20.7507 20.7761 20.5261 21 20.25 21H19.75C19.4739 21 19.2508 20.7761 19.2423 20.5001C19.1819 18.5366 18.7659 16.5988 18.013 14.7814C17.1964 12.8098 15.9994 11.0185 14.4905 9.50951C12.9815 8.00055 11.1901 6.80359 9.21861 5.98695C7.40116 5.23414 5.46343 4.81812 3.49994 4.75768C3.22393 4.74919 3 4.52613 3 4.24999V3.74999Z'
        fill={color}
      />
      <path
        d='M3 10.75C3 10.4738 3.22398 10.2488 3.49983 10.2616C4.74083 10.3194 5.96374 10.5919 7.11385 11.0683C8.4181 11.6085 9.60317 12.4004 10.6014 13.3986C11.5996 14.3968 12.3915 15.5819 12.9317 16.8861C13.4081 18.0362 13.6806 19.2592 13.7384 20.5002C13.7512 20.776 13.5261 21 13.25 21H12.75C12.4739 21 12.2514 20.776 12.2365 20.5002C12.18 19.4563 11.9469 18.4283 11.5459 17.4602C11.081 16.3379 10.3997 15.3182 9.54074 14.4593C8.6818 13.6003 7.66208 12.919 6.53982 12.4541C5.57173 12.0531 4.54368 11.82 3.49977 11.7635C3.22403 11.7486 3 11.5261 3 11.25V10.75Z'
        fill={color}
      />
      <path
        d='M4.5 21C5.32843 21 6 20.3284 6 19.5C6 18.6716 5.32843 18 4.5 18C3.67157 18 3 18.6716 3 19.5C3 20.3284 3.67157 21 4.5 21Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'rss-icon-svg'} iconRender={iconRender} {...props} />;
});

export default RSS;
